const ApplyEnum = Object.freeze({
  Čeština: 'Zobrazit více',
  Deutsch: 'Mehr',
  Français: 'Voir plus',
  Slovenčina: 'Viac zobraziť',
  Español: 'Ver más',
  English: 'More',
})

export default ApplyEnum
